window.addEventListener('DOMContentLoaded', () => {
    const links = document.querySelectorAll('.submenu-link__children');

    Array.from(links).forEach((link) => {
        link.addEventListener('click', () => {
            const content = link.parentElement.querySelector('.submenu-link__content');

            const activeLink = document.querySelector('.submenu-link--active');

            if (activeLink) {
                const content = activeLink.parentElement.querySelector('.submenu-link__content');

                content.classList.remove('submenu-link__content--active');
                activeLink.classList.remove('submenu-link--active');

                setTimeout(() => {
                    content.style.position = 'absolute';
                }, 300);   

                if (activeLink === link) return;
            }

            content.classList.toggle('submenu-link__content--active');
            link.classList.toggle('submenu-link--active');

            content.style.position = 'unset';
        });
    });
});